import React, { useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle, MessageSquareText } from "lucide-react";
import { WHATSAPP_LINK } from "../lib/config";
import QueryFormModal from "./QueryFormModal";

export default function FloatingCTAs() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="fixed z-40 bottom-4 right-4 md:bottom-6 md:right-6 flex flex-col gap-3" data-testid="floating-ctas">
        <motion.a
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
          whileHover={{ scale: 1.06 }}
          href={WHATSAPP_LINK()}
          target="_blank" rel="noreferrer"
          data-testid="floating-whatsapp"
          className="group flex items-center gap-3 bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-lg rounded-full"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="font-mono text-[11px] tracking-[0.15em] uppercase hidden sm:inline">WhatsApp Us</span>
        </motion.a>

        <motion.button
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1.35, type: "spring", stiffness: 200 }}
          whileHover={{ scale: 1.06 }}
          onClick={() => setOpen(true)}
          data-testid="floating-query"
          className="group flex items-center gap-3 bg-owt-forest text-owt-surface pl-3 pr-4 py-3 shadow-lg rounded-full"
        >
          <MessageSquareText className="w-5 h-5" />
          <span className="font-mono text-[11px] tracking-[0.15em] uppercase hidden sm:inline">Send a Query</span>
        </motion.button>
      </div>
      <QueryFormModal open={open} onOpenChange={setOpen} />
    </>
  );
}
